import { withChartLayout } from 'components/common';
import DischargePlanning from 'components/features/chart/discharge-planning/DischargePlanning';

const DischargePlanningPage = withChartLayout('Discharge Planning')(DischargePlanning);
export default DischargePlanningPage;
